<div class="group-title">
    <span class="hint-text">{{ item.title }}</span>
</div>
<div class="group-items">
    <ng-container *ngFor="let item of item.children">
        <wtf-nav-vertical-group *ngIf="item.type=='group'" [item]="item"></wtf-nav-vertical-group>
        <wtf-nav-vertical-collapse *ngIf="item.type=='collapse'" [item]="item"></wtf-nav-vertical-collapse>
        <wtf-nav-vertical-item *ngIf="item.type=='item'" [item]="item"></wtf-nav-vertical-item>
    </ng-container>
</div>
